// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This code is subject to LICENSE in root of this repository */

/* Used to detect in JavaScript if apps have loaded styles or not. */
:root {
	--reach-dialog: 1;
}

[data-reach-dialog-overlay] {
	background: hsla(0, 0%, 0%, 0.33);
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: auto;
}

[data-reach-dialog-content] {
	width: 50vw;
	margin: 10vh auto;
	background: white;
	padding: 2rem;
	outline: none;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@reach/dialog/styles.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D,oEAAoE;AACpE;CACC,iBAAiB;AAClB;;AAEA;CACC,iCAAiC;CACjC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,cAAc;AACf;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,aAAa;CACb,aAAa;AACd","sourcesContent":["/* This code is subject to LICENSE in root of this repository */\n\n/* Used to detect in JavaScript if apps have loaded styles or not. */\n:root {\n\t--reach-dialog: 1;\n}\n\n[data-reach-dialog-overlay] {\n\tbackground: hsla(0, 0%, 0%, 0.33);\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\toverflow: auto;\n}\n\n[data-reach-dialog-content] {\n\twidth: 50vw;\n\tmargin: 10vh auto;\n\tbackground: white;\n\tpadding: 2rem;\n\toutline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
